module.exports = __webpack_public_path__ + "img/skillgames-complete.6e8005a9.jpg";